import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Users } from "lucide-react";
import { api, money, shortDate } from "@/lib/api";
import { Card, PageHeader, EmptyState, inputCls } from "@/components/admin/ui";

export default function Customers() {
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => api.get("/admin/customers", { params: { q: q || undefined } }).then((r) => setList(r.data)), 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="admin-customers-page">
      <PageHeader title="Customers" subtitle="Everyone who has completed a purchase." />
      <Card className="p-0 sm:p-0 overflow-hidden">
        <div className="p-3 border-b border-zinc-200">
          <div className="relative max-w-sm">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email" className={`${inputCls} pl-9`} data-testid="customers-search-input" />
          </div>
        </div>
        {list && list.length === 0 ? (
          <EmptyState icon={Users} title="No customers yet" text="Customers are added automatically after their first paid order." testid="customers-empty" />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="customers-table">
              <thead className="bg-zinc-50 text-zinc-500 text-xs">
                <tr>
                  <th className="text-left font-medium px-4 py-2.5">Name</th>
                  <th className="text-left font-medium px-4 py-2.5">Email</th>
                  <th className="text-left font-medium px-4 py-2.5">Location</th>
                  <th className="text-right font-medium px-4 py-2.5">Orders</th>
                  <th className="text-right font-medium px-4 py-2.5">Spent</th>
                  <th className="text-right font-medium px-4 py-2.5">Last order</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-100">
                {(list || []).map((c) => (
                  <tr key={c.id} onClick={() => nav(`/admin/customers/${c.id}`)} className="hover:bg-zinc-50 cursor-pointer" data-testid={`customer-row-${c.id}`}>
                    <td className="px-4 py-3 font-medium">{c.name}</td>
                    <td className="px-4 py-3 text-zinc-600">{c.email}</td>
                    <td className="px-4 py-3 text-zinc-600">{[c.address?.city, c.address?.state].filter(Boolean).join(", ")}</td>
                    <td className="px-4 py-3 text-right">{c.orders_count}</td>
                    <td className="px-4 py-3 text-right">{money(c.total_spent)}</td>
                    <td className="px-4 py-3 text-right text-zinc-600">{shortDate(c.last_order_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
